import React, { useState } from 'react'
import { Button, Form } from 'semantic-ui-react'
import { getAccountDetails } from '../../../api'
import { Account } from '../../../types'
import { SourceAccountTypeOptions } from '../constants'
import { CounterPartyDetailsProps } from '../CounterPartyDetails'
import { getError } from '../helpers'
import styles from '../styles.module.less'
import { AccountTypeEnum } from '../Types'

const AllocationTradeFields = ({ setFieldValue, values, handleBlur, errors, touched }: CounterPartyDetailsProps) => {
  const [loading, setLoading] = useState(false)
  const [accountNumber, setAccountNumber] = useState('')
  const [hasError, setHasError] = useState(false)
  const [accountTypesOptions, setAccountTypesOptions] = useState<{ value: AccountTypeEnum; text: AccountTypeEnum }[]>(
    SourceAccountTypeOptions
  )
  const [isAccountSearched, setIsAccountSearched] = useState(false)

  const getOptionsFromResponse = (resType: AccountTypeEnum) => {
    switch (resType) {
      case AccountTypeEnum.Margin:
        return SourceAccountTypeOptions.filter(
          ({ value }) =>
            value === AccountTypeEnum.Cash || value === AccountTypeEnum.Short || value === AccountTypeEnum.Margin
        )
      case AccountTypeEnum.Dvp:
        return SourceAccountTypeOptions.filter(item => item.value === AccountTypeEnum.Dvp)
      default:
        return SourceAccountTypeOptions.filter(item => item.value === AccountTypeEnum.Cash)
    }
  }

  const handleAccountLookup = (accntNum: string) => {
    setHasError(false)
    setLoading(true)
    getAccountDetails(accntNum)
      .then(response => {
        const { data } = response
        const account: Account = data
        setFieldValue('sourceAccountType', account.accountType)
        setIsAccountSearched(true)
        account.accountType && setAccountTypesOptions(getOptionsFromResponse(account.accountType))
      })
      .catch(err => {
        console.log(err)
        setHasError(true)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const lookUpError = hasError && { content: 'No Account Found' }

  return (
    <div className={'allocation-trade-fields'}>
      <Form.Group widths="5">
        <Form.Field>
          <Form.Input
            className={'test-source-account-number'}
            label="Source Account Number"
            name="sourceAccountNumber"
            disabled={loading}
            required={true}
            value={values.sourceAccountNumber}
            error={lookUpError || getError('sourceAccountNumber', errors, touched)}
            onBlur={() => {
              handleBlur('sourceAccountNumber')
            }}
            onChange={(_, data) => {
              setFieldValue('sourceAccountNumber', data.value)
              setAccountNumber(data.value)
            }}
          />
        </Form.Field>
        <div className={styles.btnWrap}>
          <Button
            onClick={() => handleAccountLookup(accountNumber)}
            loading={loading}
            type={'button'}
            basic
            color="blue"
            className={`${styles.lookUpBtn} test-look-up-btn`}
          >
            Look-up
          </Button>
        </div>
      </Form.Group>

      <Form.Group widths="5">
        <Form.Select
          className={'test-source-account-type'}
          selection={true}
          label="Source Account Type"
          name="sourceAccountType"
          required
          disabled={loading || !isAccountSearched}
          options={accountTypesOptions}
          value={values.sourceAccountType}
          error={getError('sourceAccountType', errors, touched)}
          onBlur={() => {
            handleBlur('sourceAccountType')
          }}
          onChange={(_, data) => {
            setFieldValue('sourceAccountType', data.value)
          }}
        />
      </Form.Group>
      <Form.Group widths="5">
        <Form.Input
          className={'test-order-id'}
          label="Order Id"
          name="orderId"
          value={values.orderId}
          onChange={(_, data) => {
            setFieldValue('orderId', data.value)
          }}
          onBlur={() => {
            handleBlur('orderId')
          }}
          error={getError('orderId', errors, touched)}
        />
      </Form.Group>
    </div>
  )
}

export default AllocationTradeFields
